const VoucherType = {
  PesoVoucherCode: "peso-voucher",
  PesoDiscount: "peso-discount-voucher",
};

export default VoucherType;
